import {useQuery} from "react-query";
import {Client} from "../../../../autogenerate/api.generated.clients";

export const useChartingFaults = function(frameSerialNumber: string, startDate: Date, endDate: Date) {
    const startDateUTC = startDate.toUTCString();
    const endDateUTC = endDate.toUTCString();
    return useQuery(`${frameSerialNumber}-charting-faults-${startDate.toString()}-${endDate.toString()}`, () => new Client().alert_GetAllCompressorAlertsForTimeRange(frameSerialNumber, startDateUTC, endDateUTC))
}